export default "__VITE_ASSET__ymBsKBXe__"